import {React} from 'react'
import Sidebar from '../components/sidebar/Sidebar'
import NumOfCards from '../components/viewEntities/NumOfCards'

const ViewEntitiesPage = () => {
  
  return (
    <Sidebar>
      <NumOfCards />
    </Sidebar>
  )
}

export default ViewEntitiesPage
